// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2wKGa","name":"Header_name__2LtfB","birthday":"Header_birthday__kNVGy","skeleton":"Header_skeleton__2KtQn"};